import { BulkItem } from '../core/global';

export const calculateCustomToken = (value: string | number, bulkTokenPurchase: BulkItem[]) => {
  const tokens = Number(value)
  if (isNaN(tokens) || tokens === 0) {
    return null
  } else {
    const ordered = [...bulkTokenPurchase].sort((a, b) => {
      return b.tokens - a.tokens
    })
    const found = ordered.find(item => tokens >= Number(item.tokens))
    if (found) {
      return {
        ...found,
        tokens,
        name: 'Custom',
      }
    }
    return {
      name: 'Custom',
      tokens,
      discount: 0,
    }
  }
}